export default __webpack_public_path__ + "static/media/IWTEYP.84d35b6a.jpg";